import { render, staticRenderFns } from "./v_IframeFailedMsg.vue?vue&type=template&id=4974a80c&scoped=true&"
import script from "./v_IframeFailedMsg.vue?vue&type=script&lang=js&"
export * from "./v_IframeFailedMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974a80c",
  null
  
)

export default component.exports